export default "__VITE_ASSET__30JZjng5__"